import { graphql } from '../../graphql';
import { GetStripePriceOpenDataConfigQuery } from '../../graphql/graphql';
import execute, { recoverPartialResult } from '../../helpers/functions/api';

export const getStripePriceOpenDataConfig = () => {
  const query = graphql(`
    query getStripePriceOpenDataConfig {
      getStripePriceOpenDataConfig {
        prices {
          priceId
          amount
          areaUnit
          currency
          interval
          intervalCount
          plan
          price
          triggerSource
          volumePricing {
            max
            min
            price
          }
        }
        productKey
        productName
        productId
      }
    }
  `);

  return execute({
    query,
    withApiKey: true,
  }).catch(recoverPartialResult<GetStripePriceOpenDataConfigQuery>);
};
